// Scarico di file generati nel browser e copia negli appunti: stesse poche righe che
// prima ogni pagina riscriveva a mano.

/** Nome file dall'header Content-Disposition di una risposta axios; `fallback` se manca. */
export const filenameFromDisposition = (headers, fallback) => {
  const disposition = (headers && (headers['content-disposition'] || headers['Content-Disposition'])) || '';
  const match = disposition.match(/filename="?([^";]+)"?/);
  return match ? match[1] : fallback;
};

/**
 * Salva un Blob come file. La revoca dell'URL è ritardata: revocarlo subito dopo il click
 * può interrompere il download prima che il browser l'abbia avviato (un PDF si aprirebbe
 * in un nuovo tab invece di essere salvato).
 */
export const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => window.URL.revokeObjectURL(url), 30000);
};

/** Salva un testo come file (per un CSV il BOM UTF-8 lo aggiunge `toCsv`). */
export const downloadText = (filename, text, mime = 'text/csv;charset=utf-8') => {
  downloadBlob(new Blob([text], { type: mime }), filename);
};

/**
 * Copia un testo negli appunti. Se il browser rifiuta l'API (contesto non sicuro, permessi),
 * ripiega su una textarea selezionata. Restituisce true se la copia è riuscita.
 */
export const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    let ok = false;
    try {
      ok = document.execCommand('copy');
    } catch {
      ok = false;
    }
    area.remove();
    return ok;
  }
};
